import { T }                  from 'defa-object';
import ControlModule          from 'scripts/poppet/control-module';
import { Vue }                from 'vue/defavue';
import template               from './view-control-security.jst.html';

const selectors = {
	toggleButton: '[data-toggle=expand-spoiler]',
};

const sliderOptions = [
	{ value: 'ON', title: T.tc( 'Security', 'On' ), titleContext: 'SecuritySetting' },
	{ value: 'OFF', title: T.tc( 'Security', 'Off' ), titleContext: 'SecuritySetting' }
];

let vueSecurityActivatedStrip = '';
let vueExpandedSecurity = '';

const ControlSecurityView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template          : template,
	expandedNavState  : 'unit:control:security',
	compressedNavState: 'unit:control:overview',
	
	ui: {
		toggle        : selectors.toggleButton,
	},
	
	
	events: {
		'click @ui.toggle'         : 'onClickToggle',
	},
	
	className() {
		return this._getClassName( 'control-security' );
	},
	
	//
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	/**
	 * Triggers when the html is rendered in the DOM.
	 * @void
	 */
	
	
	onDomRefresh: function () {
		this.createVueComponents();
	},
	
	createSecurityActivatedStrip: function(){
		let self = this;
		vueSecurityActivatedStrip = new Vue( {
			el: '#secutity-activated-strip',
			bb() {
				return {
					model: self.model,
				}
			},
			data() {
				return {
					securityMainSliderValue: 'ON',
					sliderOptions,
				}
			},
			methods: {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName]= 'ON' === newValue;
					self.save( data )
				},
			},
			watch: {
				'model.securityActivated': function (newAttribute){
					this.securityMainSliderValue = newAttribute ? 'ON' : 'OFF';
				}
			},
			
			created() {
				this.securityMainSliderValue = this.model.securityActivated ? 'ON' : 'OFF';
			}
		} );
	},
	
	createVueExpandedContent: function(){
		let self = this;
		
		vueExpandedSecurity = new Vue( {
			el: '#vue-expanded-security',
			bb() {
				return {
					model: self.model,
				}
			},
			data() {
				return {
					fenceAlertValue: false,
					ignitionAlertValue: false,
					triggerError: '',
					speedAlertValue: 'ON',
					speedThresholdValue: 0,
					speedThresholdOptions: [],
					sliderOptions,
				}
			},
			methods: {
				saveAlarmMask(attributeName) {
					if(this.fenceAlertValue || this.ignitionAlertValue){
						let data = {};
						this.triggerError = '';
						data.alarmMask = {
							speedAlert: 'ON' === this.speedAlertValue,
							fenceAlert: this.fenceAlertValue,
							ignitionAlert: this.ignitionAlertValue
						};
						self.save( data )
					} else{
						if(attributeName !== undefined){
							this[attributeName] = !this[attributeName];
						}
						this.triggerError = T.tc( 'Security', 'At least one option must be selected' );
					}
				},
				saveSpeedThreshold(newValue){
					let data = {};
					data.speedThreshold = parseInt(newValue, 10);
					self.save( data )
				},
				
				createSpeedThresholdOptions() {
					let speed = 30;
					let speedMeasurement =  T.tc( 'Security', 'km/h' );
					while ( speed <= 250 ) {
						let speedOption   = {};
						speedOption.text  = speed + ' ' + speedMeasurement;
						speedOption.value = speed;
						this.speedThresholdOptions.push(speedOption);
						speed += 5;
					}
					
				}
			},
			watch: {
				'model.alarmMask': function (newAttribute){
					this.speedAlertValue = newAttribute.speedAlert ? 'ON' : 'OFF';
					this.fenceAlertValue = newAttribute.fenceAlert;
					this.ignitionAlertValue = newAttribute.ignitionAlert;
				},
				'model.speedThreshold': function (newAttribute){
					this.speedThresholdValue = JSON.parse(JSON.stringify(newAttribute));
				}
			},
			
			created() {
				this.speedAlertValue = this.model.alarmMask && this.model.alarmMask.speedAlert ? 'ON' : 'OFF';
				this.fenceAlertValue = this.model.alarmMask && this.model.alarmMask.fenceAlert;
				this.ignitionAlertValue = this.model.alarmMask && this.model.alarmMask.ignitionAlert;
				this.speedThresholdValue = this.model.speedThreshold ?  JSON.parse(JSON.stringify(this.model.speedThreshold)): 0;
				this.createSpeedThresholdOptions();
			}
		})
	},
	
	
	save: function (attributes) {
		this.model.set('isValidData', false);
		try {
			this.model.save( attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response, options) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			} );
		} catch ( err ) {
			alert( 'Failed syncing' );
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},
	
	createVueComponents: function(){
		this.createSecurityActivatedStrip();
		this.createVueExpandedContent();
	}
} );


export default ControlSecurityView;
